import { Link, useLocation } from "react-router-dom";
import { BarChart2, Calendar, Clock, Home } from "lucide-react";

const navItems = [
  { to: "/", label: "ダッシュボード", icon: Home },
  { to: "/calendar", label: "カレンダー", icon: Calendar },
  { to: "/releases", label: "発表履歴", icon: Clock },
];

export function Layout({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b border-gray-200 sticky top-0 z-10">
        <div className="max-w-6xl mx-auto px-4 flex items-center h-14 gap-1">
          <Link to="/" className="flex items-center gap-2 mr-6 font-semibold text-blue-700">
            <BarChart2 size={20} />
            <span className="hidden sm:inline">Macro Monitor</span>
          </Link>
          {navItems.map(({ to, label, icon: Icon }) => (
            <Link
              key={to}
              to={to}
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm transition-colors ${
                pathname === to
                  ? "bg-blue-50 text-blue-700 font-medium"
                  : "text-gray-600 hover:bg-gray-100"
              }`}
            >
              <Icon size={15} />
              {label}
            </Link>
          ))}
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-4 py-6">{children}</main>
    </div>
  );
}
